import React from "react";
import { Card, Spin } from "antd";

import "./AdnCard.css";

const AdnCard = ({ title, children, loading, minHeight}) => {
  return (
    <Card title={title} style={{ minHeight: minHeight || "80vh", }}>
      {loading ? <>
        <Spin style={{ marginTop: "25%", marginLeft: "50%"}}></Spin>
        </> : <>
        {children}
        </>}
    </Card>
  );
};

export default AdnCard;
